import React from 'react';
import {NavLink} from "react-router-dom";
import CopyString from "../../../pages/parcels/form_v3/copyString";
import moment from "moment";
import {getRoles} from "../../../services/userRights";
import FieldModal from "../../Modals/FieldModal";
import NumberInput from "../../../controls/numberInput";
import DateTimeInput from "../../../controls/dateTimeInput";
import {costFormat} from "../../../services/cost";
import IssueStatusInput from '../../../grids/controls/issueStatusInput';
import Logos from "../../../pages/parcels/form_v3/logos";
import Info from "../../Info";
import {buildParcelExternalTrackingUrl} from "../../../services/trackingLink";
import ClientManagerInput from '../../../grids/controls/clientManagerInput';

// Вспомогательная функция для определения параметра cameFrom
const getCameFrom = () => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/reports')) {
        return 'reports';
    } else if (currentPath.includes('/parcels/list')) {
        return 'parcels';
    }
    return 'parcels'; // по умолчанию
};

// Вспомогательная функция для формирования URL посылки
const getParcelUrl = (parcelId) => {
    const cameFrom = getCameFrom();
    return `/parcels/${parcelId}/new?cameFrom=${cameFrom}`;
};

const Edit = ({col, row, reload, roles, withSync, inputComponent, label, canEdit}) => {
    let userRoles = getRoles();
    const editPermission = (!roles && canEdit) || userRoles.find(r => (roles || []).includes(r));

    return (
        editPermission ? <FieldModal
            label={label || `Изменить поле "${col.title}" для ${row.number}`}
            col={col}
            row={row}
            reload={reload}
            InputComponent={inputComponent}
            withSync={withSync}
        >
            <a className='copy-string__icon'>
                <span className="glyphicon glyphicon-pencil"></span>
            </a>
        </FieldModal> : null
    )
}

const TableCellValueGrid = ({column, row, gridName, canEditByRow, reload}) => {
    const editFields = {
        externalNumber: {
            withSync: true,
            label: `Изменить внешний номер посылки ${row.number}`
        },
        discountForCustomer: {
            inputComponent: NumberInput
        },
        issueStatus: {
            inputComponent: IssueStatusInput
        },
        clientManager: {
            inputComponent: ClientManagerInput
        },
        deliveryDate: {
            inputComponent: DateTimeInput
        },
        departureDate: {
            inputComponent: DateTimeInput
        },
        actualDepartureDate: {
            inputComponent: DateTimeInput
        },
        actualDeliveryDate: {
            inputComponent: DateTimeInput
        }
    }

    const cellType = (col) => {
        switch (col.type) {
            case 'receivedDate':
                return <div>
                    {
                        row[col.fieldName] ?
                            <span>{moment(row[col.fieldName]).format('YYYY.MM.DD')}</span>
                            : null
                    }
                </div>
            case 'deliveryDate':
            case 'departureDate':
            case 'initialPlannedDepartureDate':
            case 'initialPlannedDeliveryDate':
                return <span>
                    {
                        row[col.fieldName] ?
                            <span>{moment(row[col.fieldName]).format('DD.MM.YYYY')}</span>
                            : null
                    }
                </span>
            case 'date':
            case 'createdDate':
            case 'actualDeliveryDate':
            case 'actualDepartureDate':
            case 'statusChangedAt':
            case 'lastIssueDeadline':
                return <div>
                    {
                        row[col.fieldName] ?
                            <span>{moment(row[col.fieldName]).format('DD.MM.YYYY')}, <span
                                className='color_grey'>{moment(row[col.fieldName]).format('HH:mm')}</span></span>
                            : null
                    }
                </div>
            case 'number':
                return <div>
                    {row.number && (gridName === 'incoming-parcels' ? 
                        <a style={{marginLeft: '5px'}} className='total__change-btn_name'
                           onClick={(e) => {
                               e.preventDefault();
                               window.openIncomingParcelModal && window.openIncomingParcelModal(row.id);
                           }}
                           href="#">{row.number}</a> :
                        <NavLink 
                            style={{marginLeft: '5px', color: '#459EFF'}} 
                            className='total__change-btn_name'
                            to={getParcelUrl(row.id)}
                        >{row.number}</NavLink>
                    )}
                </div>;
            case 'id':
            case 'parcelId':
                // Для отчетов - "Идентификатор посылки"
                return <div>
                    {row.id && <NavLink 
                        style={{color: '#459EFF'}} 
                        className='total__change-btn_name'
                        to={getParcelUrl(row.id)}
                    >{row.id}</NavLink>}
                </div>;
            case 'linkToCard':
                return <div>
                    {row.id && <NavLink style={{marginLeft: '5px'}} className='total__change-btn_name'
                                        to={`/dictionary/${gridName}/${row.id}`}>{row[col.fieldName]}</NavLink>}
                </div>;
            case 'externalNumber':
                return row.externalNumber && <CopyString
                        text={row.externalNumber}
                        onClick={row.parcelUrl ? () => window.open(buildParcelExternalTrackingUrl(row.parcelUrl, row.externalNumber), '_blank') : true}
                    >
                        {row.externalNumber}
                    </CopyString>;
            case 'deliveredDate':
                return <div>
                    {
                        row[col.fieldName]
                            ? <span>{moment(row[col.fieldName]).format('DD.MM.YYYY')}</span>
                            : <span style={{ color: '#aaa' }}>Не вручено</span>
                    }
                </div>
            case 'status':
                // Разная логика отображения статусов для разных гридов
                if (gridName === 'incoming-parcels') {
                    return <div style={{whiteSpace: 'nowrap'}}>
                        {row.status === 'Delivered' || row.status === 1 ? 'Вручено' : 'Получено'}
                    </div>
                } else {
                    // Для остальных гридов (отчеты, обычные посылки) используем оригинальное значение
                    return <div style={{whiteSpace: 'nowrap'}}>
                        {row.status}
                    </div>
                }
            case 'awardAgent':
            case 'profitPooling':
            case 'insuranceCost':
            case 'insuranceCostPrice':
            case 'feeUsingYourCarrier':
            case 'costPrice':
            case 'actualCostPrice':
            case 'createByManagerCost':
            case 'discountForCustomer':
            case 'actualCostForAgent':
            case 'deliveryCost':
            case 'actualDeliveryCost':
                return row[col.fieldName] ? costFormat(Number.parseFloat(row[col.fieldName]).toFixed(2)) : ''
            case 'company':
                return row[col.type] || '';
            case 'shipmentCompany':
                // Поддержка обоих вариантов имен полей (camelCase и PascalCase)
                const carrierServiceDescription = row.carrierServiceDescription || row.CarrierServiceDescription || '';
                const carrierServiceName = row.carrierServiceName || row.CarrierServiceName || '';
                const carrier = row.carrier || row.Carrier || '';
                const carrierCode = row.carrierCode || row.CarrierCode || '';
                
                // Временная отладка - можно удалить после проверки
                if (carrier && !carrierServiceDescription) {
                    console.log('Tariff description missing:', {
                        carrier,
                        carrierCode,
                        carrierServiceName,
                        rowKeys: Object.keys(row)
                    });
                }
                
                return <div className='shipment-company'>
                    {carrier && <Info
                        name={carrier}
                        label={carrierServiceName}
                        text={carrierServiceDescription}
                        position={'right'}
                        offset={[7]}
                    />}
                    <Logos
                        name={carrierCode}
                    />
                </div>;
            case 'issueStatus':
                return (row[col.type] && row[col.type].label) || '';
            case 'approximateWeight':
            case 'approximateVolume':
            case 'cargoWeight':
            case 'cargoVolume':
            case 'weight':
            case 'volume':
            case 'packagesCount':
            case 'cargoPackages':
                // Форматирование числовых значений для веса, объема и количества мест
                const numValue = row[col.fieldName];
                if (numValue === null || numValue === undefined || numValue === '') {
                    return '';
                }
                // Преобразуем строку в число, заменяя запятую на точку если нужно
                const numStr = String(numValue).replace(',', '.');
                const parsedNum = Number.parseFloat(numStr);
                if (isNaN(parsedNum)) {
                    // Если не число, возвращаем как есть
                    return <div style={{whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word'}}>
                        {numValue}
                    </div>;
                }
                // Форматируем число с правильным количеством знаков после запятой
                // Для веса и объема - до 5 знаков, для количества мест - целое число
                const formattedValue = (col.fieldName === 'packagesCount' || col.fieldName === 'cargoPackages')
                    ? parsedNum.toFixed(0)
                    : parsedNum.toFixed(5).replace(/\.?0+$/, ''); // Убираем лишние нули в конце
                // Заменяем точку на запятую для отображения в русской локали
                const displayValue = formattedValue.replace('.', ',');
                return <div style={{whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word'}}>
                    {displayValue}
                </div>;
            default:
                const textValue = row[col.fieldName] || '';
                // Оборачиваем текст в div для правильного переноса строк
                return <div style={{whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word'}}>
                    {textValue}
                </div>
        }
    }

    const params = editFields[column.fieldName] || {};

    const canEdit = column.canEdit && (canEditByRow ? canEditByRow(column, row) : true);

    return <span>
        {cellType(column)}
        <Edit
            col={column}
            row={row}
            reload={reload}
            canEdit={canEdit}
            {...params}
        />
    </span>
};

export default TableCellValueGrid;


// WEBPACK FOOTER //
// ./App/components/Table/components/TableCellValueGrid.jsx